import * as React from 'react';
import { colors } from '../../../index';

const IconHelp = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 15 15",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0a7.5 7.5 0 10.02 15.02A7.5 7.5 0 007.5 0zm0 14.02A6.52 6.52 0 117.52.97a6.52 6.52 0 01-.02 13.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.43a2.4 2.4 0 00-2.4 2.39.5.5 0 101 0 1.41 1.41 0 111.4 1.4.5.5 0 00-.5.5v1.71a.5.5 0 101 0V8.16a2.4 2.4 0 00-.5-4.73zm0 6.84a.62.62 0 100 1.23.62.62 0 000-1.23z"
  }));
};

export default IconHelp;